const getLeafIds = (nodeOrNodes) => {
  if (Array.isArray(nodeOrNodes)) {
    return nodeOrNodes.flatMap(getLeafIds)
  }

  if (!nodeOrNodes || typeof nodeOrNodes !== 'object') {
    return []
  }

  const children = Array.isArray(nodeOrNodes.children) ? nodeOrNodes.children : []
  if (children?.length) {
    return children.flatMap(getLeafIds)
  }
  const id = nodeOrNodes.id

  return id === undefined || id === null ? [] : [id]
}

export { getLeafIds }
